import { useId } from 'react';
import { cn } from '../cn';

export interface SliderProps {
  label: string;
  value: number;
  min: number;
  max: number;
  step?: number;
  onChange: (v: number) => void;
  /** Suffix printed after the value (px, s, ms, %, ×). */
  unit?: string;
  /** Custom value text (e.g. '1.2 ×', '80 %'). */
  format?: (v: number) => string;
  disabled?: boolean;
  /** Mobile row variant: 400 14px label + 12px mono value, 12/16 padding, top line. */
  row?: boolean;
  className?: string;
}

/** Design slider: label row (micro label fg4 + mono 11px value fg2) over a 2 px range track. */
export function Slider({ label, value, min, max, step = 1, onChange, unit, format, disabled, row, className }: SliderProps) {
  const id = useId();
  const txt = format ? format(value) : `${value}${unit ? ` ${unit}` : ''}`;
  return (
    <div className={cn('flex flex-col', row ? 'gap-2.5 border-t border-line px-4 pb-3.5 pt-3' : 'gap-2', disabled && 'opacity-50', className)}>
      <div className={cn('flex justify-between', row && 'items-baseline')}>
        <label htmlFor={id} className={row ? 'text-lg font-normal leading-[1.3] text-fg' : 'micro text-fg4'}>
          {label}
        </label>
        <span className={cn('font-mono font-normal tabular', row ? 'flex-none text-right text-base leading-[1.3] text-fg3' : 'text-sm text-fg2')}>{txt}</span>
      </div>
      <input id={id} type="range" min={min} max={max} step={step} value={value} disabled={disabled} onChange={(e) => onChange(+e.target.value)} />
    </div>
  );
}
